var $ = global.$;

/**
 * Some useful utilities
 * @exports lib/utils
 * @author Simon Buerger
 */
var utils = {
  $el: $('<div class="block-overlay"></div>'),
  block: function(){
    $('body').append(this.$el);
    this.$el.addClass('is-blocked');
    this.$el.velocity('fadeIn');
    $('body').addClass('is-blocked');
  },
  unblock: function(){
    this.$el.removeClass('is-blocked').remove();
    $('body').height('auto').removeClass('is-blocked');
  },
  /**
   * Cross-browser method for getting the window dimensions
   *
   * @returns {Object} Object with two parameters - width and height
   * @instance
   */
  getWindow: function(){
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName('body')[0],
        x = w.innerWidth || e.clientWidth || g.clientWidth,
        y = w.innerHeight|| e.clientHeight|| g.clientHeight;

    return {
      width: x,
      height: y
    };
  }
};

module.exports = utils;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/lib/utils.js
 ** module id = 25
 ** module chunks = 0 1
 **/